// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3tqMy","name":"Header_name__2PKPN","birthday":"Header_birthday__wC04e","skeleton":"Header_skeleton__HvhrG"};